/**
 * The decision models Prompt Lab offers for decision-model labs, as
 * OpenRouter Decisions slugs with display labels.
 *
 * Mirror of `DECISION_MODELS` in `backend/app/services/decision_model_config.py`, which
 * also rejects any other model on save; `backend/tests/test_mirror_parity.py`
 * pins the two. Clef (Cloudflare) is Jev-compatible but not served on
 * OpenRouter, so it is absent until OpenRouter carries it.
 */
export interface DecisionModel {
  value: string;
  label: string;
}

export const DECISION_MODELS: readonly DecisionModel[] = [
  { value: '~typesafe/jev-latest', label: 'TypeSafe Jev (latest)' },
  { value: 'typesafe/jev-1.14', label: 'TypeSafe Jev 1.14' },
  { value: 'typesafe/jev-1.13', label: 'TypeSafe Jev 1.13' },
  { value: 'liquid/d1-ultra', label: 'Liquid D1 Ultra' },
  { value: 'liquid/d1', label: 'Liquid D1' },
  { value: 'upstage/solar-decide', label: 'Upstage Solar Decide' },
  { value: 'inception/mercury-decide', label: 'Inception Mercury Decide' },
  { value: 'openai/gpt-6-luna-decisions', label: 'OpenAI GPT-6 Luna Decisions' },
  { value: 'perplexity/pplx-decider-v1.2', label: 'Perplexity Decider V1.2' },
  { value: 'microsoft/microsoft-decision-1', label: 'Microsoft Decision-1' },
];

/**
 * The models a search prompt version (primary or backup) may name: every decision model, and Gemini
 * 3.8 Flash for full text. Mirror of `SEARCH_MODELS` in `backend/app/services/search_model_catalog.py`,
 * pinned by `backend/tests/test_mirror_parity.py`.
 */
export const SEARCH_MODELS: readonly DecisionModel[] = [
  ...DECISION_MODELS,
  { value: 'google/gemini-3.8-flash', label: 'Gemini 3.8 Flash' },
];
